export default {
  title: 'Comment trouvez-vous {{name}} ?',
  description: 'Votre avis est anonyme et nous aide à nous améliorer.',
  upload_google_review: {
    title: 'Notez-nous & soyez récompensé',
  },
};
